import { getGameImage } from '@/hooks/useGameImage';
import type { Game } from '@/models/game';

export const GameImage = ({ game }: { game: Game }) => {
  return (
    <img
      draggable={false}
      className="w-full max-h-48 object-cover rounded-sm"
      alt={game.name}
      src={game.image ?? getGameImage(game.game_code)}
    />
  );
};
